import { render, staticRenderFns } from "./HomePrimaryCards.vue?vue&type=template&id=5955f648&scoped=true"
import script from "./HomePrimaryCards.vue?vue&type=script&lang=js"
export * from "./HomePrimaryCards.vue?vue&type=script&lang=js"
import style0 from "./HomePrimaryCards.vue?vue&type=style&index=0&id=5955f648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955f648",
  null
  
)

export default component.exports